import { createInstance as createInstanceLib } from 'i18next';
import { LanguagesResources } from '../../consts';

const DEFAULT_NS = 'translation';
const DEFAULT_OPTIONS = {
	debug: process.env.NODE_ENV === 'development',
	defaultNS: DEFAULT_NS,
	fallbackLng: 'en',
	interpolation: {
		escapeValue: false, // not needed for react as it escapes by default
	},
	react: {
		useSuspense: true,
	},
} as const;

const createi18nInstance = (options: Options) => {
	const instanceOptions = {
		...DEFAULT_OPTIONS,
		...options,
	};
	const resourcesWithNamespace = getResourcesWrappedWithNamespace(instanceOptions);

	const i18n = createInstanceLib({
		...instanceOptions,
		resources: resourcesWithNamespace,
	});
	i18n.init();

	return i18n;
};

export { createi18nInstance, DEFAULT_OPTIONS };

export function getResourcesWrappedWithNamespace<
	T extends Pick<Options, 'resources' | 'defaultNS'>,
>(options: T) {
	return Object.fromEntries(
		Object.entries(options.resources).map(([lang, translations]) => [
			lang,
			{ [`${options.defaultNS}`]: translations },
		]),
	);
}

type Options = Omit<NonNullable<Parameters<typeof createInstanceLib>['0']>, 'resources'> & {
	resources: LanguagesResources;
};
